
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import { Box, Button, ButtonGroup, Paper, Tab, Tabs, Tooltip } from "@material-ui/core";
import { TabPanel, useTabChangeHelper } from "../../components/Tabs";
import { useCallback, useContext, useEffect } from "react";
import { LANDLORD_ROLE } from "../../store/User";
// import BillingForm from '../../../components/organization/BillingForm';
import config from "../../config";
// import Leases from '../../../components/organization/Leases';
import Members from "../../components/organization/Members";
import { observer } from "mobx-react-lite";
import Page from "../../components/Page";
import { setOrganizationId } from "../../utils/fetch";
import { StoreContext } from "../../store";
// import ThirdPartiesForm from '../../../components/organization/ThirdPartiesForm';
import useFillStore from "../../hooks/useFillStore";
import useTranslation from "next-translate/useTranslation";
import { withAuthentication } from "../../components/Authentication";
import BillingForm from "../../components/organization/BillingForm";
import PaymentSettings from "../../components/settings/PaymentSettings";
import NotificationSettings from "../../components/settings/NotificationSettings";
import AccountSettings from "../../components/settings/AccountSettings";
import LandlordForm from "../../components/organization/LandlordForm";
import TemplateSettings from "../../components/settings/TemplateSettings";
import Hidden from "../../components/HiddenSSRCompatible";
import { HelpOutline as HelpOutlineIcon, Notifications, Payment, Person, SupervisorAccount } from "@material-ui/icons";
import { useRouter } from "next/router";
import { settingSteps } from "../../components/shepherdStep/guideStep";
import RentSettings from "../../components/settings/RentSettings";
// import { PermissionGate } from '../../utils/PermissionProvider'; // No longer needed - tabs are filtered individually
import { usePermissions } from "../../utils/PermissionProvider";
import ResetSettings from "../../components/settings/ResetSettings";
import { FeatureGuard } from "../../components/subscriptions";
// Components
const SettingTabs = observer(({ handleTabChange, tabSelectedIndex, onSubmit }) => {
    const store = useContext(StoreContext);
    const { t } = useTranslation("common");
    const { hasPermission } = usePermissions();
    const onSubmitted = useCallback(({ isOrgNameChanged, isLocaleChanged }) => {
        if (isOrgNameChanged || isLocaleChanged) {
            window.location.assign(`${config.BASE_PATH}/${store.organization.selected.locale}/${store.organization.selected.name}/settings`);
        }
    }, [store.organization.selected]);
    // Define all possible tabs with their permissions
    const allTabs = [
        {
            key: "account",
            permission: "setting:account",
            label: t("Account Information (Landlord)"),
            className: "shepherd-setting-tabAccountInfo",
            icon: <Person />,
            component: (<>
          <AccountSettings onSubmit={onSubmit} onSubmitted={onSubmitted}/>
          <ResetSettings />
        </>)
        },
        {
            key: "members",
            permission: "setting:members",
            label: t("Member List"),
            className: "shepherd-setting-tabMemberAdmin",
            icon: <SupervisorAccount />,
            component: (
            // store.user?.items ? <Members memberList={store.user.items} onSubmit={onSubmit} /> : null
            <FeatureGuard variant="section" featureName="Member Setting" minPlan="standard">
          <Members memberList={store.user.items} onSubmit={onSubmit}/>
        </FeatureGuard>)
        },
        {
            key: "notifications",
            permission: "setting:notifications",
            label: t("Notifications"),
            className: "shepherd-setting-tabRealmNotification",
            icon: <Notifications />,
            component: (<FeatureGuard variant="section" featureName="Notification Setting" minPlan="standard">
          {/* <TemplateSettings /> */}
          <NotificationSettings onSubmit={onSubmit} onSubmitted={onSubmitted}/>
        </FeatureGuard>)
        },
        {
            key: "payment",
            permission: "setting:payment",
            label: t("Payment Method"),
            className: "shepherd-setting-tabPaymentMethod",
            icon: <Payment />,
            component: (<FeatureGuard variant="section" featureName="Payment Method Setting" minPlan="standard">
          <PaymentSettings onSubmit={onSubmit} onSubmitted={onSubmitted}/>
        </FeatureGuard>)
        },
        {
            key: "rent",
            permission: "setting:rent",
            label: t("Rent"),
            className: "shepherd-setting-tabRent",
            icon: <Payment />,
            component: (<FeatureGuard variant="section" featureName="Rent Setting" minPlan="standard">
          <RentSettings onSubmit={onSubmit} onSubmitted={onSubmitted}/>
        </FeatureGuard>)
        },
    ];
    // Filter tabs based on permissions
    const visibleTabs = allTabs.filter((tab) => hasPermission(tab.permission));
    // Ensure selected tab index is valid
    const validTabIndex = Math.min(tabSelectedIndex, visibleTabs.length - 1);
    return (<>
      <Hidden smDown>
        <Tabs variant="scrollable" value={validTabIndex} onChange={handleTabChange} aria-label="Setting tabs">
          {visibleTabs.map((tab, index) => (<Tab key={tab.key} label={tab.label} className={tab.className} wrapped/>))}
        </Tabs>
      </Hidden>
      <Hidden mdUp>
        <Tabs variant="fullWidth" value={validTabIndex} onChange={handleTabChange} aria-label="Setting tabs">
          {visibleTabs.map((tab, index) => (<Tab key={tab.key} icon={tab.icon} className={tab.className} wrapped/>))}
        </Tabs>
      </Hidden>
      {visibleTabs.map((tab, index) => (<TabPanel key={tab.key} value={validTabIndex} index={index}>
          {tab.component}
        </TabPanel>))}
    </>);
});
/**
 * @param {*} store
 */
async function fetchData(store, router, t, handleTabChange) {
    const tourSteps = settingSteps(store, router, t, handleTabChange);
    const results = await Promise.all([
        // store.subscription.fetchData(),
        store.subscription.fetchByRealmId(store.organization.selected._id),
        store.property.fetch(),
        store.organization.fetchAndSelect(),
        store.user.fetch(store.organization?.selected._id),
        store.guideTour.setupTour(tourSteps),
    ]);
    const isSkipGuide = store.user.isSkipTourGuide.settings;
    if (!isSkipGuide) {
        store.guideTour.startTour(store.user);
    }
    return results;
}
const Settings = observer(() => {
    const router = useRouter();
    const { t } = useTranslation("common");
    const store = useContext(StoreContext);
    const { handleTabChange, tabSelectedIndex } = useTabChangeHelper();
    const [fetching] = useFillStore(fetchData, [router, t, handleTabChange]);
    // read tabselected
    useEffect(() => {
        if (!router.isReady)
            return;
        const raw = router.query.tabSelectedIndex;
        const idx = Array.isArray(raw) ? parseInt(raw[0], 10) : parseInt(raw || "0", 10);
        const clamped = Number.isNaN(idx) ? 0 : idx;
        handleTabChange(null, clamped);
    }, [router.isReady]);
    // rename url
    const handleTabChangeWithUrl = useCallback((event, newIndex) => {
        handleTabChange(event, newIndex);
        router.replace({
            pathname: router.pathname,
            query: { ...router.query, tabSelectedIndex: String(newIndex) }
        }, undefined, { shallow: true });
    }, [router, handleTabChange]);
    const onStartTour = useCallback(() => {
        const tourSteps = settingSteps(store, router, t, handleTabChange);
        store.guideTour.setupTour(tourSteps);
        store.guideTour.startTour(store.user);
    }, [store, router, t, handleTabChange]);
    const onSubmit = useCallback(async (orgPart) => {
        const organization = {
            // Do not update keys when the thirdParties is not touched
            // thirdParties: {
            //   gmail: { appPasswordUpdated: false },
            //   mailgun: { apiKeyUpdated: false },
            //   b2: { applicationKeyIdUpdated: false, applicationKeyUpdated: false },
            // },
            ...store.organization.selected,
            paymentMethod: {
                midtransUpdated: false,
                xenditUpdated: false
            },
            ...orgPart
        };
        const { status, data: updatedOrganization } = await store.organization.update(organization);
        if (status !== 200) {
            switch (status) {
                case 422:
                    return store.pushToastMessage({
                        message: t("Some fields are missing"),
                        severity: "error"
                    });
                case 403:
                    return store.pushToastMessage({
                        message: t("You are not allowed to update the settings"),
                        severity: "error"
                    });
                case 409:
                    return store.pushToastMessage({
                        message: t("The organization name already exists"),
                        severity: "error"
                    });
                default:
                    return store.pushToastMessage({
                        message: t("Something went wrong"),
                        severity: "error"
                    });
            }
        }
        else {
            store.pushToastMessage({
                message: t("Success update data"),
                severity: "success"
            });
        }
        store.organization.setSelected(updatedOrganization, store.user);
        store.organization.setItems([
            ...store.organization.items.filter(({ _id }) => _id !== updatedOrganization._id),
            updatedOrganization,
        ]);
        setOrganizationId(updatedOrganization._id);
    }, [store, t]);
    return (<FeatureGuard featureName="Setting" minPlan="starter">
      <Page maxWidth="xl" loading={fetching} ActionBar={<Box display="flex" justifyContent="end">
            <Hidden smDown>
              {store.guideTour.canShowGuide(store.user) && (<Tooltip title={t("Page Guide")} aria-label="properties-guide">
                  <Button variant="contained" style={{
                    minHeight: 40,
                    minWidth: 40,
                    padding: 0
                }} onClick={onStartTour}>
                    <HelpOutlineIcon />
                  </Button>
                </Tooltip>)}
            </Hidden>
            <Hidden mdUp>
              <ButtonGroup variant="text">
                {store.guideTour.canShowGuide(store.user) && (<Tooltip title={t("Page Guide")} aria-label="properties-guide">
                    <Button style={{
                    minHeight: 40,
                    minWidth: 40,
                    padding: 0
                }} onClick={onStartTour}>
                      <HelpOutlineIcon />
                    </Button>
                  </Tooltip>)}
              </ButtonGroup>
            </Hidden>
          </Box>}>
        <Paper>
          <SettingTabs handleTabChange={handleTabChangeWithUrl} tabSelectedIndex={tabSelectedIndex} onSubmit={onSubmit}/>
        </Paper>
      </Page>
    </FeatureGuard>);
});
const __Next_Translate__Page__1a19d46ed9d__ = withAuthentication(Settings);

    export default __appWithI18n(__Next_Translate__Page__1a19d46ed9d__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
    });
  